import React from 'react';

interface ExportModeToggleProps {
  enabled: boolean;
  onToggle: (value: boolean) => void;
}

export function ExportModeToggle({ enabled, onToggle }: ExportModeToggleProps) {
  return (
    <label className="flex items-center gap-2 text-xs text-gray-400 select-none">
      <input
        type="checkbox"
        className="accent-blue-500"
        checked={enabled}
        onChange={(e) => onToggle(e.target.checked)}
      />
      Snapshot completo
    </label>
  );
}


